import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgEdit = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M13.747 20.443H21M12.78 3.795a2.245 2.245 0 0 1 3.116-.303l1.733 1.347a2.14 2.14 0 0 1 .72 2.984c-.034.054-9.537 11.941-9.537 11.941a1.7 1.7 0 0 1-1.31.633l-3.638.046-.82-3.47c-.115-.489 0-1.001.316-1.396zM11.021 6.001l5.452 4.187" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
